import { inject } from 'vue';

export function useTypeChecker() {
  const { testWorkQueueTypes } = inject('constants');

  const extractSlug = (item) => {
    return item && typeof item === 'object' ? item.slug : item;
  };

  const isActiveType = (type) => {
    if (typeof type !== 'object' || type === null) return true;
    return !type.deleted_at && !type.pivot?.deleted_at;
  };

  const isValidType = (types, typeSlug) => {
    if (!Array.isArray(types)) return false;
    return types.some(type => isActiveType(type) && extractSlug(type) === typeSlug);
  };

  function hasRemotePrintingType(types) {
    return isValidType(types, testWorkQueueTypes.REMOTE_PRINTING);
  }

  function hasIsoSkippedType(types) {
    return isValidType(types, testWorkQueueTypes.ISO_SKIPPED);
  }

  function hasAutomaticDesignType(types) {
    return isValidType(types, testWorkQueueTypes.AUTOMATIC_DESIGN);
  }

  function hasUnchangedType(types) {
    return isValidType(types, testWorkQueueTypes.UNCHANGED);
  }

  function hasExternalOfPrimoupType(types) {
    return isValidType(types, testWorkQueueTypes.EXTERNAL_OF_PRIMOUP);
  }

  function hasMillingCenterType(types) {
    return isValidType(types, testWorkQueueTypes.MILLING_CENTER);
  }

  return { 
    hasRemotePrintingType, 
    hasIsoSkippedType, 
    hasAutomaticDesignType,
    hasUnchangedType,
    hasExternalOfPrimoupType,
    hasMillingCenterType,
    extractSlug,
    isActiveType,
  };
}
